import styled from "styled-components";

const StyledHeader = styled.header`
  & {
    position: fixed;
    width: 100%;
    z-index: 5;
    transition: height 0.4s, transform 0.3s ease-in-out;
    background-color: rgb(24, 12, 51);
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    padding-bottom: 0.5rem;
  }
  
  & .header-logo {
    padding-top: 0.5rem;
    width: auto;
    height: 3.75rem;
  }
  
  & nav a {
    all: unset;
    margin: 0 0.5rem;
    font-family: "Inter";
    font-style: normal;
    font-optical-sizing: auto;
    font-weight: 300;
    font-size: 22px;
    line-height: 27px;
    color: #ffffff;
    transition: 0.4s color;
    cursor: pointer;
  }
  
  & .menu-icon {
    display: none;
  }
  
  & nav a:hover {
    color: #ff7a00;
  }
  
  & nav.mobile {
    display: none;
  }
    
  & nav.desktop {
    display: flex;
    flex-wrap: no-wrap;
    justify-content: end;
    align-items: center;
  }
  
  @media (max-width: 991px) {
    &.navbar-hidden {
      transform: translateY(-100%);
      transition: all 0.3s ease-in;
    }
    
    & .menu-icon {
      display: initial;
      margin: 0 1rem;
      cursor: pointer;
    }
    
    & nav.desktop {
      display: none;
    }
    
    & nav.mobile {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-flow: column;
      overflow: hidden;
      height: ${({ menuToggle }) => (menuToggle ? "100%" : "0")};
      transition: 0.4s;
      width: 100%;
    }
    
    & nav.mobile a {
      margin: 0.5rem;
    }
    
    .userwaydiv-desktop {
      display: none !important;
    }
    
    .userwaydiv-mobile {
      margin-top: 5rem !important;
      position: absolute !important;
      right: 5%;
      z-index: 1;
      /* Fix for immediate appearance */
      opacity: ${({ menuToggle }) => (menuToggle ? "1" : "0")};
      visibility: ${({ menuToggle }) => (menuToggle ? "visible" : "hidden")};
      transition: opacity 0.1s ease-in, visibility 0.1s ease-in;
    }
  }
  
  @media (min-width: 992px) {
    .userwaydiv-mobile {
      display: none !important;
    }
    
    .userwaydiv-desktop {
      margin-top: -10px;
    }
  }
  
  @media (max-width: 575px) {
    & .header-logo {
      padding-left: 0.5rem;
    }
  }
  
  @media (max-width: 500px) {
    & .header-logo {
      height: 3rem;
    }
  }
`;

export default StyledHeader;